import React, { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { Stars } from "@/components/valhalla/SiteReviews";

const STATUS_TXT = { pending: "En attente de validation par l'équipe HalgarOS", published: "Publié sur halgaros.com — merci !", hidden: "Non publié" };

export default function MyReviewCard() {
  const { user } = useAuth();
  const [f, setF] = useState({ author_name: user?.name || "", role: "", rating: 5, text: "", consent: false });
  const [status, setStatus] = useState(null);
  useEffect(() => {
    api.get("/reviews/mine").then(({ data }) => { if (data) { setF({ author_name: data.author_name, role: data.role || "", rating: data.rating, text: data.text, consent: true }); setStatus(data.status); } }).catch(() => {});
  }, []);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const save = async () => {
    if (f.text.trim().length < 10) return toast.error("Votre avis doit faire au moins 10 caractères");
    if (!f.consent) return toast.error("Cochez l'accord de publication");
    try { const { data } = await api.put("/reviews/mine", f); setStatus(data.status); toast.success("Merci ! Votre avis sera publié après validation"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail) || "Erreur"); }
  };
  const remove = async () => { await api.delete("/reviews/mine"); setStatus(null); setF((x) => ({ ...x, text: "", consent: false })); toast.success("Avis retiré"); };
  return (
    <div className="space-y-3" data-testid="my-review-card">
      {status && <p data-testid="my-review-status" className="text-xs text-zinc-400">{STATUS_TXT[status]}</p>}
      <div className="grid gap-3 sm:grid-cols-2">
        <div><Label className="text-zinc-400">Nom affiché</Label><Input data-testid="my-review-name" value={f.author_name} onChange={(e) => set("author_name", e.target.value)} className="mt-1 border-zinc-800 bg-zinc-950" /></div>
        <div><Label className="text-zinc-400">Fonction (optionnel)</Label><Input data-testid="my-review-role" placeholder="Gérant, DJ, traiteur…" value={f.role} onChange={(e) => set("role", e.target.value)} className="mt-1 border-zinc-800 bg-zinc-950" /></div>
      </div>
      <div><Label className="text-zinc-400">Note</Label><div className="mt-1.5"><Stars value={f.rating} onChange={(n) => set("rating", n)} testid="my-review-rating" /></div></div>
      <div><Label className="text-zinc-400">Votre avis</Label><Textarea rows={4} data-testid="my-review-text" value={f.text} onChange={(e) => set("text", e.target.value)} className="mt-1 border-zinc-800 bg-zinc-950" placeholder="Qu'est-ce que HalgarOS a changé dans votre quotidien ?" /></div>
      <label className="flex items-start gap-2 text-xs text-zinc-400">
        <input type="checkbox" data-testid="my-review-consent" checked={f.consent} onChange={(e) => set("consent", e.target.checked)} className="mt-0.5 h-4 w-4 accent-[#FF6A00]" />
        J'accepte que mon avis, mon nom, ma fonction et le nom de mon entreprise soient publiés sur halgaros.com.
      </label>
      <div className="flex gap-2">
        <Button data-testid="my-review-submit" onClick={save} className="rounded-full bg-[#FF6A00] font-semibold text-white hover:bg-[#E65F00]">{status ? "Mettre à jour mon avis" : "Envoyer mon avis"}</Button>
        {status && <Button variant="ghost" data-testid="my-review-delete" onClick={remove} className="rounded-full text-zinc-400">Retirer</Button>}
      </div>
    </div>
  );
}
